import * as moment from "moment";
import 'moment/locale/pt-br';

export class DatasHelper {

  public static hoursString: string;
  public static minutesString: string;
  public static hours: number;
  public static minutes: number;


  static formatDate(date?: Date, hours?: number, minutes?: number) {

    let x = new Date(date);
    return moment(x.setHours(hours, minutes)).toDate();

  }

  formatarData(data: any) {
    if(data) {
      return moment(data).format('DD/MM/YYYY');
    } else {
      return '-'
    }
  }

  formatarDataMask(data: any, mask: string) {
    if(data) {
      return moment(data).format(mask);
    } else {
      return '-'
    }
  }

  getDia(dateLocal: any) {
    if(dateLocal) {
      return moment(dateLocal).format('DD');
    } else {
      return '-';
    }
  }

  getMes(dateLocal: any) {
    if(dateLocal) {
      return moment(dateLocal).format('MMMM');
    } else {
      return '-';
    }
  }

  static getAno(dateLocal: any) {
    if(dateLocal) {
      return moment(dateLocal).format('YYYY');
    } else {
      return '-';
    }
  }


  verificarDataVencida(date: Date): boolean {

    if(date !== undefined) {
      const currentDate =  moment().utc().toDate();
      const dataEnviada =  moment(date).utc().toDate()
      return dataEnviada > currentDate;
    } else {
      return false;
    }

  }

  /**
   * Recebe a data local (com hora, minuto e segundo) e retorna o equivalente em UTC
   * @param dateLocal Data em formato Local
   * @return Date no formato local
   */
  static dateLocalToUtc(dateLocal: Date) {
    // Converte a data atual para UTC
    return moment(dateLocal).utc().toDate(); // retorna no formato "2021-01-25T12:31:39.701Z"
  }

  /**
   * Recebe a data UTC e retorna a data em horário local
   * @param dateUtc Data em formato UTC
   * @return Date no formato local
   */
  static dateUtcToLocal(dateUtc: Date) {
    return moment(dateUtc).local().toDate();
  }

  /**
   * Converte uma string ou data para o formato de data local
   * @param dateLocal Date ou string para conversão
   * @return Date no formato local
   */
  static date(dateLocal: Date | string) {
    if (dateLocal == null)
      return null;

    return moment(dateLocal).toDate();
  }

  /**
   * Converte uma string ou data para o formato de data local com horario 00:00
   * @param dateLocal Date ou string para conversão
   * @return Date no formato local
   */
  static startDate(dateLocal: Date | string) {
    if (dateLocal == null)
      return null;

    return moment(dateLocal).startOf('day').toDate();
  }

  /**
   * Converte uma string ou data para o formato de data local com horario 23:59:59
   * @param dateLocal Date ou string para conversão
   * @return Date no formato local
   */
  static endDate(dateLocal: Date | string) {
    if (dateLocal == null)
      return null;

    return moment(dateLocal).endOf('day').toDate();
  }

  /**
   * Retorna a data atual
   * @return Date da data atual no formato local
   */
  now() {
    return moment().toDate();
  }

  /**
   * Retorna a data atual subtraindo 7 dias
   * @return Date da data atual no formato local
   */
  static lastWeek() {
    return moment().subtract(7, 'days').toDate();
  }

  /**
   * Retorna a string de Horas e Minutos (HH:mm)
   * @param date Objeto de data com o horário definido
   * @returns string de hora e minuto no formato 24h
   */
  static getHourString(date: Date) {
    return date.getHours() + ":" + date.getMinutes();
  }


  static getMoment(date: Date | string) {
    return moment(date);
  }
}
